/**
 *
 *
 * @export MarkFileRequestModel
 * @class MarkFileRequestModel
 */
export class MarkFileRequestModel {
    // マークコード
    public MarkCode: string = <string>'';
    // マークコード連番
    public MarkCodeBranch: string = <string>'';
    // 使用開始 受注コード
    public StartOrderCode: string = <string>'';
    // 使用終了 受注コード
    public EndOrderCode: string = <string>'';
    // 使用停止区分
    public Enabled: string = <string>'';
    // データグリッド上の選択位置
    public SelectedIndex = 0;

    /**
     * コンストラクタ
     * 変数の初期化のみを行う。
     */
    constructor() {
    }
}
